import { IReactComponent } from 'mobx-react/dist/types/IReactComponent';
import { Component, createContext } from 'react';

export const AutoInjectContext = createContext({});

export function autoinject<T extends IReactComponent>(target: T): T {
    (target as any).contextType = AutoInjectContext;
    return target;
}

export function inject(target: Component, key: string): any {
    return {
        get(this: Component): any {
            if (this.context) return this.context[key];
            else {
                // this.context is undefined in a constructor, this is a hack
                return (this.constructor as any).contextType._currentValue[key];
            }
        },
    };
}
